import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../utills";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { green, lightText } from "../constants/colors";
import suzuki from "../assets/images/suzuki.svg";
import merchedese from "../assets/images/merchedes.svg";
import audi from "../assets/images/audi.svg";
import tata from "../assets/images/tata.svg";
import nissan from "../assets/images/nissan.svg";
import jeep from "../assets/images/jeep.svg";
import volkswagen from "../assets/images/volkswagen.svg";
import ferrari from "../assets/images/ferrari.svg";
import mazda from "../assets/images/mazda.svg";
import mitsubishi from "../assets/images/mitsubishi.svg";
import lamborghini from "../assets/images/lamborghini.svg";
import tesla from "../assets/images/tesla.svg";
import toyota from "../assets/images/toyota.svg";
import CustomCard from "./customCard";
import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";
import { useGeneralInfo } from "../context/generalContext";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
export default function DreamCar() {
    const [generalInfo] = useGeneralInfo();
  
  const token = localStorage.getItem("access_token");
  const [value, setValue] = React.useState("1");
  const [carMakers, setCarMakers] = useState([]);
  const [bodyTypes, setBodyTypes] = useState([]);
  const [cities, setCities] = useState([]);

  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
console.log("value....", value);

  const fetchCarMaker = async () => {
    try {
      const res = await axios.get(baseUrl + "get_car_makers/");
      if (res.status === 200) {
        setCarMakers(res?.data?.car_makers);
      }
      console.log("car makers", res);
    } catch (error) {
      console.error("error:", error);
    }
  };
  const fetchBodyTypes = async () => {
    try {
      const res = await axios.get(baseUrl + "bodytype");
      if (res.status === 200) {
        setBodyTypes(res?.data);
      }
      console.log("body types...", res);
    } catch (error) {
      console.error("error:", error);
    }
  };
  const fetchCities = async () => {
    try {
      const res = await axios.get(baseUrl + "cities/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setCities(res?.data);
      }
      console.log("citiess", res);
    } catch (error) {
      console.error("error:", error);
    }
  };
  useEffect(() => {
    // fetchCarMaker();
    fetchBodyTypes();
    // fetchCities();
  }, []);
  return (
    <Box
      sx={{
        width: { xs: "100%", lg: "90%" },
        margin: "0 auto",
        typography: "body1",
      }}
    >
      <div className="text-center mb-8">
        <p className="text-[30px] md:text-[40px] font-bold">
          Search Your Dream Car
        </p>
        <p style={{ color: lightText }}>
          There are <strong>{generalInfo?.makes?.length}+</strong> Brand Category
          Available
        </p>
      </div>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderTop: 1,
            borderColor: "divider",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "90%",
            margin: "0 auto",
            marginBottom:"20px"
          }}
        >
          <TabList onChange={handleChange}
          aria-label="customized tabs"
          sx={{
            "& .MuiTabs-indicator": {
              color: green,
              backgroundColor: green, // Change the active tab indicator color
            },
            "& .MuiTab-root": {
              color: "gray", // Default color
              fontWeight: 600,
              textTransform: "none",
            },
            "& .MuiTab-root:hover": {
              color: green, // Hover color
            },
            "& .Mui-selected": {
              color: green, // Selected tab color
              fontWeight: "bold",
            },
          }}
          >
            <Tab sx={{ fontWeight: 600 }} label="Brand" value="1" />
            <Tab sx={{ fontWeight: 600 }} label="Body Type" value="2" />
            <Tab sx={{ fontWeight: 600 }} label="Location" value="3" />
          </TabList>
          {value=="1"?
        <p
        onClick={() =>
          navigate("/brands")
        }
        className="hidden md:block font-[600] hover cursor-pointer hover:text-customGreen"
      >
        Explore Brands <EastIcon fontSize="14px" />
      </p>:
      value=="3"?
      <p
            onClick={() =>
              navigate("/location")
            }
            className="hidden md:block font-[600] hover cursor-pointer hover:text-customGreen"
          >
            Explore Locations <EastIcon fontSize="14px" />
          </p>:""  
        }
        </Box>
        <TabPanel value="1">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {generalInfo?.makes?.slice(0, 12).map((item) => (
              <Grid xs={6} sm={4} md={4} lg={2}>
                <div
                  onClick={() =>
                    navigate("/car-listing", {
                      state: {
                        maker_id: item?.id,
                        name: item?.car_maker,
                      },
                    })
                  }
                
                >
                 <div className="flex justify-center items-center mb-2 bg-[#F3F3F3] w-[80px] h-[80px] rounded rounded-[100%] m-auto cursor-pointer hover hover:shadow-md">
                    <img
                      src={`${baseUrl}logos/${item?.logo}`}
                      alt={item?.logo}
                      style={{ width: "60px", height: "40px" }}
                    />
                  </div>
                  {/* <div className="flex justify-center items-center gap-1"> */}
                  <p className="text-center">{item?.car_maker}</p>
                  {/* <p className="text-center">({item?.post_count})</p>
                  </div> */}
                </div>
              </Grid>
            ))}
         
          </div>
          <p
              onClick={() =>    
                navigate("/brands", {
                state: {
                  category_id: 1,
                },
              })}
              className="md:hidden font-[600] hover cursor-pointer text-center mt-8"
            >
              Explore More <EastIcon fontSize="14px" />
            </p>
        </TabPanel>
        <TabPanel value="2">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {bodyTypes?.map((item, index) => (
              <Grid key={index} xs={6} sm={4} md={4} lg={2}>
                <div
                  onClick={() =>
                    navigate("/car-listing", {
                      state: {
                        body_type_id: item?.id,
                      },
                    })
                  }
                 
                >
                 <div className="flex justify-center items-center mb-2 bg-[#F3F3F3] w-[80px] h-[80px] rounded rounded-[100%] m-auto cursor-pointer hover hover:shadow-md">
                    <img
                      src={`${baseUrl}logos/${item?.logos}`}
                      alt={item?.logos}
                      style={{
                        width: "60px",
                        height: index === 7 ? "65px" : "65px",
                        color: "gray",
                      }}
                    />
                  </div>
                  <p className="text-center">{item?.body_type}</p>
                  {/* <p>({item?.post_count})</p> */}
                </div>
              </Grid>
            ))}
          
          </div>
          {/* <p
              onClick={() => navigate("/body-type")}
              className="md:hidden font-[600] hover cursor-pointer text-center mt-8"
            >
              Explore More <EastIcon fontSize="14px" />
            </p> */}
        </TabPanel>
        <TabPanel value="3">
          <Grid container spacing={3}>
            {generalInfo?.cities?.slice(0, 12)?.map((item) => (
              <Grid xs={6} sm={4} md={4} lg={2}>
                <CustomCard
                  onClick={() =>
                    navigate("/car-listing", {
                      state: {
                        city_id: item?.id,
                      },
                    })
                  }
                  xs={{
                    textAlign: "center",
                    boxShadow: "none",
                    border: "1px solid rgba(0,0,0,.08)",
                    borderRadius: "8px",
                    ":hover": {
                      border: "1px solid rgba(0,0,0,0.5)",
                      cursor: "pointer",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    {/* <img src={item?.logo} alt={item?.logo} /> */}
                  </Box>
                  <p>{item?.name}</p>
                  <p>({item?.post_count})</p>
                </CustomCard>
              </Grid>
            ))}
           
          </Grid>
          <p
              onClick={() => navigate("/location")}
              className="md:hidden font-[600] hover cursor-pointer text-center mt-8"
            >
              Explore More <EastIcon fontSize="14px" />
            </p>
        </TabPanel>
      </TabContext>
    </Box>
  );
}
